import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';
import { AdminUserRoleKey } from '@chiroup/core/types/AdminUserRole.type';

export type AdminUserRow = {
  ID: number;
  email: string;
  firstName: string | null;
  lastName: string | null;
  roleKey: AdminUserRoleKey;
  status: 'invited' | 'active' | 'disabled';
  mfaEnrolled: boolean;
  lastLoginAt: string | null;
  createDate: string;
};

export type CreateAdminUserBody = {
  email: string;
  firstName: string;
  lastName: string;
  roleKey: AdminUserRoleKey;
};

export type UpdateAdminUserBody = {
  firstName?: string;
  lastName?: string;
  roleKey?: AdminUserRoleKey;
  status?: 'active' | 'disabled';
};

const adminUsersService = () => {
  const list = async (): Promise<{ items: AdminUserRow[] }> => {
    return ChiroUpAPI.get('api', '/admin-users', {});
  };

  const create = async (body: CreateAdminUserBody): Promise<AdminUserRow> => {
    return ChiroUpAPI.post('api', '/admin-users', { body });
  };

  const update = async (id: number, body: UpdateAdminUserBody): Promise<AdminUserRow> => {
    return ChiroUpAPI.put('api', `/admin-users/${id}`, { body });
  };

  const remove = async (id: number): Promise<void> => {
    return ChiroUpAPI.del('api', `/admin-users/${id}`, {});
  };

  const resetPassword = async (id: number): Promise<void> => {
    return ChiroUpAPI.post('api', `/admin-users/${id}/reset-password`, {
      body: {},
    });
  };

  const resetMfa = async (id: number): Promise<void> => {
    return ChiroUpAPI.post('api', `/admin-users/${id}/reset-mfa`, {
      body: {},
    });
  };

  return { list, create, update, remove, resetPassword, resetMfa };
};

export default adminUsersService();
